<template>
  <div>
    <div class="login-popup">
      <div class="title">连接已断开，请重连</div>
      <div class="choice_part">
        <ul>
          <li @click="cancle" class="cancle">取消</li>
          <li @click="reconnect" class="active">确定</li>
        </ul>
        <!-- <div @click="cancle" class="cancle">取消</div>
        <div @click="reconnect" class="active">确定</div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    reconnect() {
      this.$emit("reconnect");
    },
    cancle() {
      this.$router.push("/");
    }
  }
};
</script>


<style lang="scss" scoped>
@import "~assets/styles/mixin";
.login-popup {
  border-radius: 0.1rem;
  background: #fff;
  text-align: center;
  width: 6rem;
  margin: 0 auto;
  .title {
    padding: 0.7rem 0.65rem;
    @include sc(0.32rem, #333);
  }
  .choice_part {
    border-top: 0.025rem solid #ddd;
    ul {
      display: flex;
      justify-content: center;
      padding: 0.12rem 0;
      li {
        border-right: 0.025rem solid #ddd;
        @include sc(0.3rem, #666);
        line-height: 0.8rem;
        padding-right: 0.8rem;
      }
      li.active {
        color: #0a95ff;
      }
      li:last-child {
        border-right: none;
        padding-left: 0.8rem;
        padding-right: 0;
      }
    }
  }
}
.van-popup {
  background: none;
}
</style>